import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { UserLoginAPIConstant } from "../constants/user-login.constant";
import { AppConfig } from "../../../services/app-config.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { MessageServiceService } from "../../feature/pilms/service/message-service.service";
import { environment } from "../../../environments/environment";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";

@Injectable({
  providedIn: 'root'
})
export class UserLoginService {

  httpOptions: any = {
    Headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  apiUrl = AppConfig.settings.apiUrl;
  umpUrl = AppConfig.settings.umpUrl;


  isUserExists: boolean = false;
  isPermissionApiCall: boolean = false;

  userPermission$ = new BehaviorSubject<any[]>([]);
  userPermissionObs$ = this.userPermission$.asObservable();


  userName$ = new BehaviorSubject<string>('');
  userNameObs$ = this.userName$.asObservable();


  constructor(private httpClient: HttpClient,
    private messageServiceService: MessageServiceService,
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
  ) {

  }
  isUserLoggedIn$ = new Subject<boolean>();


  setUserLoggedIn(data: boolean) {
    this.isUserLoggedIn$.next(data);
  }
  getUserLoggedIn(): Observable<boolean> {
    return this.isUserLoggedIn$.asObservable();
  }

  async userExistsCheck(userName: any): Promise<any> {
    return new Promise((resolve, reject) => {

      this.checkUserExists(userName).subscribe({
        next: async (response: any) => {
          if (response != null && response) {
            this.isUserExists = true;
            let result = await this.fetchUserDetails(userName);
            resolve(result);
          } else {
            localStorage.clear();
            sessionStorage.clear();
            this.oktaAuth.signOut().then(() => {
              window.location.href = environment.userAccessRequestURL;

            });
          }
        },
        error: (err: any) => {
          localStorage.clear();
          sessionStorage.clear();
          this.oktaAuth.signOut().then(() => {
            window.location.href = environment.userAccessRequestURL;

          });
        }
      });
    });
  }

  async fetchUserDetails(userName: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userDetails(userName).subscribe({
        next: (response: any) => {
          this.setSessionVariables(response);

          resolve(response);
        },
        error: (err: any) => {
          console.error('Error fetching user details:', err);
          reject(err);
        }
      });
    });
  }


  setSessionVariables(response: any) {

    this.userName$.next(response?.name ?? '');
    this.userPermission$.next(response.roles);
    this.messageServiceService.setuserIdMessage({ userId: response.id ?? 0 });

    sessionStorage.setItem('userDetails', JSON.stringify(response));
    sessionStorage.setItem('userId', response.id ?? 0);
    sessionStorage.setItem('userRoles', JSON.stringify(response.roles));
    localStorage.setItem('CSMRTUserLastLoggedIn', new Date().toString());

    if (response.reportRoles) {
      sessionStorage.setItem('reportRoles', JSON.stringify(response.reportRoles));
    }

  }

  checkUserExists(userName: any) {
    return this.httpClient.get(`${this.apiUrl}${UserLoginAPIConstant.CHECKUSEREXISTS}?userName=${userName}`, this.httpOptions);
  }

  userDetails(userName: any) {
    return this.httpClient.get(`${this.apiUrl}${UserLoginAPIConstant.AUTHORIZELOGGEDINUSER}?userName=${userName}`, this.httpOptions);
  }

  setUserLoggedInDate() {
    return this.httpClient.post(`${this.umpUrl}HybrisWS/rest/OS_CommonService/SetUserLoggedInDate?key=423e577c-f73a-4023-b8d4-3aaf119f1d02`, { 'preventLoader': true }, this.httpOptions);
  }
}